import { render, staticRenderFns } from "./ListItemClassification.vue?vue&type=template&id=099872fb&scoped=true&"
import script from "./ListItemClassification.vue?vue&type=script&lang=js&"
export * from "./ListItemClassification.vue?vue&type=script&lang=js&"
import style0 from "./ListItemClassification.vue?vue&type=style&index=0&id=099872fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099872fb",
  null
  
)

export default component.exports